import { Typography } from "@atoms/typography";
import { FC } from "react";
import styled from "styled-components";

export interface PaymentMethodsProps {
  installmentPaymentEnabled: boolean;
  paymentMethod: string;
  onSelectPaymentMethod: (paymentMethod: string) => void;
}

export const PaymentMethods: FC<PaymentMethodsProps> = ({
  installmentPaymentEnabled,
  paymentMethod,
  onSelectPaymentMethod,
}) => {
  const handleSelectPayment: React.ChangeEventHandler<HTMLInputElement> = (
    e
  ) => {
    onSelectPaymentMethod(e.target.value);
  };
  return (
    <Container>
      <Typography>Selecciona la forma de pago:</Typography>
      <div className="payment-methods">
        <Typography as="label" variant="body2">
          <input
            type="radio"
            name="payment_method"
            value="full"
            checked={paymentMethod === "full"}
            onChange={handleSelectPayment}
          />
          Pago completo
        </Typography>
        <Typography as="label" variant="body2">
          <input
            type="radio"
            name="payment_method"
            value="half-now"
            checked={paymentMethod === "half-now"}
            disabled={!installmentPaymentEnabled}
            onChange={handleSelectPayment}
          />
          Pago 50% ahora y el resto 15 días antes de la fecha de entrada.
        </Typography>
      </div>
    </Container>
  );
};

const Container = styled.div`
  .payment-methods {
    margin-top: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
`;
